module.exports = __webpack_public_path__ + "img/LiberacionDePuertaEsclusa.72a47a1e.svg";